export default __webpack_public_path__ + "static/media/Rectangle 110.de036780.jpg";